import React, { useEffect } from "react"
import { global as GlobalStyles } from "./styles"
import { Normalize } from "styled-normalize"
// import Map from "./Map"
import { pageview } from "./analytics"
import UAParser from "ua-parser-js"
import get from "lodash/get"
import qs from "qs"
const parser = new UAParser()

// const frameStyles = {
//   position: "absolute",
//   width: "100vw",
//   height: "100vh",
//   border: "none",
// }

function App() {
  useEffect(pageview, [])
  useEffect(() => {
    const redirectUser = () => {
      const agent = parser.getResult()
      const isIOS = get(agent, "os.name") === "iOS"
      const isAndroid = get(agent, "os.name") === "Android"
      if (isIOS) {
        window.location.href = "http://itunes.apple.com/us/app/1504630954"
      } else if (isAndroid) {
        window.location.href = "http://play.google.com/store/apps/details?id=com.curbflow"
      } else {
        window.location.href = "https://www.curbflow.com/#download"
      }
    }

    const recordPageviewAndRedirect = () => {
      const timeout = setTimeout(() => {
        redirectUser()
      }, 1000)

      const query = qs.parse(document.location.search.slice(1))
      const label = query["utm_source"]

      window.gtag("event", "page_view", {
        page_title: "Download the curbFlow App",
        event_callback: () => {
          window.gtag("event", "APP_DOWNLOAD_LINK_CLICKED", {
            event_category: "APP",
            event_label: label,
            event_callback: () => {
              console.log("callback triggered")
              clearTimeout(timeout)
              redirectUser()
            },
          })
        },
      })
    }

    recordPageviewAndRedirect()
  }, [])

  return (
    <div className="App">
      <Normalize />
      <GlobalStyles />
      {/* <iframe title="download" src="https://www.curbflow.com/#download" style={frameStyles} /> */}
    </div>
  )
}

export default App
